import(/* webpackMode: "eager" */ "/opt/thedesperatetrader/app/error.tsx");
